export default __webpack_public_path__ + "static/media/08.16760ec9.png";